import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getSolicitudesPorEstado = async (fechaStart , fechaEnd ) => {
    try {
      const userInfo = fetchUser();
      if (userInfo != null) {
        const {data}  = await Axios.get(`/reportes/SolicitudesPorEstado?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}`);
        return  data;
      } else {
        return [];
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getResumenEquipos = async (fechaStart , fechaEnd ) => {
    try {
      const userInfo = fetchUser();
      if (userInfo !== null) {
       const {data}  = await Axios.get(
        `/reportes/ResumenEquipos?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}`);
        return  data;
      } else {
        return [];
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getResumenCostoMaquina = async (fechaStart , fechaEnd ) => {
    try {
      const userInfo = fetchUser();
      if (userInfo !== null) {
      const {data}  = await Axios.get(
        `/reportes/ResumenCentroMaquina?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}`);
        return  data;
      } else {
        return [];
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };

    export const getBitacoraSolicitud = async (numeroSolicitud) => {
    try {
      
      const {data}  = await Axios.get(`/reportes/BitacoraSolicitudNew?numero=${numeroSolicitud}`);
       // console.log(" DATOS " + JSON.stringify(data));
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const getBitacoraEquipo = async (numeroSolicitud) => {
    try {

      const {data}  = await Axios.get(`/reportes/BitacoraEquipo?codigoEquipo=${numeroSolicitud}`);
       // console.log(" DATOS " + JSON.stringify(data));
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getEstatusEquipos = async () => {
    try {
      const userInfo = fetchUser();
      if (userInfo !== null) {
        const { data } = await Axios.get(`/reportes/EstatusEquipos?empresa=${userInfo.empresa}`);
        return data;
      } else {
        return [];
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };